import React, { useEffect, useState } from "react";
import {
    Card,
    Typography,
    Stack,
    CircularProgress,
    Box,
    Chip,
    Button,
    Avatar,
    Divider
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import { useNavigate } from "react-router-dom";
import EventPopup from "./EventPopup";
import dayjs from "dayjs";

const UpcomingEventsCard = ({ user }) => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(false);

    const [open, setOpen] = useState(false);

    const [selectedEvent, setSelectedEvent] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        const fetchEvents = async () => {
            if (!user?.jwt) return;

            setLoading(true);

            try {
                const res = await fetch(
                    `${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule`,
                    {
                        headers: { Authorization: `Bearer ${user.jwt}` },
                    }
                );

                if (!res.ok) throw new Error("Błąd pobierania events-schedule");

                const data = await res.json();

                const filteredData = data.filter((event) => {
                    const eventDate = new Date(event.startDate);
                    const now = new Date();
                    return eventDate > now;
                });

                console.log('filteredData', filteredData)

                const mappedEvents =
                    filteredData?.map((event) => ({
                        id: event.id,
                        name: event.name,
                        date: event.startDate,
                        start: event.startDate,
                        end: event.endDate,
                        meta: {
                            type: event.type,
                            status: event.status,
                            description: event.description,
                            participants: event.participants,
                            creator: {
                                id: event.creator.id,
                                name: event.creator.username,
                            },
                        }
                    })) ?? [];

                mappedEvents.sort((a, b) => new Date(a.date) - new Date(b.date));

                setEvents(mappedEvents);
            } catch (err) {
                console.error("Błąd pobierania wydarzeń:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchEvents();
    }, [user?.jwt]);

    console.log('events', events)

    return (
        <Card sx={{ mb: 3, p: 3, borderRadius: 3, boxShadow: 3 }}>
            <Typography variant="h6" mb={2} fontWeight={600}>
                Wydarzenia, w których może wziąć udział Twoje dziecko w najbliższym czasie
            </Typography>

            {loading && (
                <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                    <CircularProgress />
                </Box>
            )}

            {!loading && events.length === 0 && (
                <Typography color="text.secondary">Brak dostępnych wydarzeń</Typography>
            )}

            <Stack spacing={2}>
                {events.map((event) => (
                    <>
                        <Card
                            key={event.id}
                            sx={{
                                p: 2,
                                borderRadius: 2,
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 2,
                                background: "#f9fafb",
                                boxShadow: 1,
                                transition: "0.2s",
                                "&:hover": {
                                    boxShadow: 4,
                                },
                            }}
                        >
                            <Avatar
                                sx={{ bgcolor: "#294e6b", width: 40, height: 40, mt: 0.5 }}
                            >
                                <EventIcon />
                            </Avatar>

                            <Box sx={{ flex: 1 }}>
                                <Typography fontWeight={600}>{event.name}</Typography>

                                {event.date && (
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5 }}
                                    >
                                        <EventIcon sx={{ fontSize: 16, color: "#294e6b" }} />{" "}
                                        {/* {new Date(event.date).toLocaleString()} */}
                                        {dayjs(event.date).format('DD.MM.YYYY HH:mm')}
                                    </Typography>
                                )}

                                {event.meta.description && (
                                    <Typography variant="body2" sx={{ mt: 1 }}>
                                        {event.meta.description}
                                    </Typography>
                                )}

                                <Box sx={{ mt: 1 }}>
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={() => {
                                            // navigate("/vr/callendar")
                                            setSelectedEvent(event);
                                            setOpen(true);
                                        }}
                                    >
                                        Szczegóły
                                    </Button>
                                </Box>
                            </Box>
                        </Card>

                    </>
                ))}
                <EventPopup
                    open={open}
                    onClose={() => {
                        setOpen(false);
                        setSelectedEvent(null);
                    }}
                    event={selectedEvent}
                />
            </Stack>
        </Card>
    );
};

export default UpcomingEventsCard;



// import React, { useEffect, useState } from "react";
// import {
//     Card,
//     Typography,
//     Stack,
//     CircularProgress,
//     Box,
//     Chip,
//     Button
// } from "@mui/material";

// const UpcomingEventsCard = ({ user }) => {
//     const [events, setEvents] = useState([]);
//     const [loading, setLoading] = useState(false);

//     console.log('user', user.jwt)

//     useEffect(() => {
//         const fetchEvents = async () => {
//             if (!user?.jwt) return;

//             setLoading(true);

//             try {
//                 const res = await fetch(
//                     `${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule`,
//                     {
//                         headers: {
//                             Authorization: `Bearer ${user.jwt}`,
//                         },
//                     }
//                 );

//                 if (!res.ok) {
//                     throw new Error("Błąd pobierania events-schedule");
//                 }

//                 const data = await res.json();

//                 console.log("events raw:", data);

//                 const mappedEvents =
//                     data?.map((event) => ({
//                         id: event.id,
//                         name: event.title,
//                         date: event.startDate,
//                         description: event.description,
//                     })) ?? [];

//                 // sortowanie po dacie (najbliższe pierwsze)
//                 mappedEvents.sort(
//                     (a, b) => new Date(a.date) - new Date(b.date)
//                 );

//                 setEvents(mappedEvents);
//             } catch (err) {
//                 console.error("Błąd pobierania wydarzeń:", err);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchEvents();
//     }, [user?.jwt]);



//     console.log('events', events)

//     return (
//         <Card sx={{ mb: 3, p: 3 }}>
//             <Typography variant="h6" mb={2}>
//                 Wydarzenia, w których może wziąć udział Twoje dziecko w najbliższym czasie
//             </Typography>

//             {loading && (
//                 <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
//                     <CircularProgress />
//                 </Box>
//             )}

//             {!loading && events.length === 0 && (
//                 <Typography color="text.secondary">
//                     Brak dostępnych wydarzeń
//                 </Typography>
//             )}

//             <Stack spacing={2}>
//                 {events.map((event) => (
//                     <Card
//                         key={event.id}
//                         sx={{
//                             p: 2,
//                             borderRadius: 3,
//                             background: "#f9fafb",
//                         }}
//                     >
//                         <Typography fontWeight={600}>
//                             {event.name}
//                         </Typography>

//                         {event.date && (
//                             <Typography variant="body2" color="text.secondary">
//                                 {new Date(event.date).toLocaleString()}
//                             </Typography>
//                         )}

//                         {event.description && (
//                             <Typography variant="body2" sx={{ mt: 1 }}>
//                                 {event.description}
//                             </Typography>
//                         )}
//                     </Card>
//                 ))}
//             </Stack>

//         </Card>
//     );
// };

// export default UpcomingEventsCard;
